import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BodyTextContainerComponent } from '@dynamic-components/body-text-container';
import { UIModule } from '@shared/ui';

import { BodyTextImageContainerModule } from '../body-text-image-container/body-text-image-container.module';
import {
  AccordionContainerComponent,
  accordionContainerResolver,
} from './accordion-container.component';

const MODULES = [
  CommonModule,
  UIModule,
  BodyTextContainerComponent,
  BodyTextImageContainerModule,
];

const DECLARATIONS = [AccordionContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class AccordionContainerModule {
  static entry = AccordionContainerComponent;
  static componentDataResolver = accordionContainerResolver;
}
